export default __webpack_public_path__ + "static/media/btn_webtoon_default.2557405e.png";